import { DateTime } from "luxon";

import type { Model } from "./Model";
import type { PublicModel } from "./PublicModel";
import type { SharedModel } from "./SharedModel";

export function orderModels<A extends Model[] | PublicModel[] | SharedModel[]>(
  modelsArray: A,
  order: "modified" | "created" | "name"
) {
  const modelsToSort = modelsArray.slice() as A;
  switch (order) {
    case "modified":
      modelsToSort.sort((a, b) => {
        const aFileMod = DateTime.fromJSDate(
          new Date("lastVersion" in a ? a?.lastVersion?.created || 0 : 0)
        );
        const aModelModified = DateTime.fromJSDate(
          new Date("modified" in a ? a.modified : 0)
        );
        const aMod = DateTime.max(aModelModified, aFileMod);

        const bFileMod = DateTime.fromJSDate(
          new Date("lastVersion" in b ? b?.lastVersion?.created || 0 : 0)
        );
        const bModelModified = DateTime.fromJSDate(
          new Date("modified" in b ? b.modified : 0)
        );
        const bMod = DateTime.max(bModelModified, bFileMod);

        if (aMod > bMod) return -1;
        if (aMod == bMod) return 0;
        else return 1;
      });
      break;

    case "created":
      modelsToSort.sort((a, b) => {
        if (!("created" in a)) return 0;
        if (!("created" in b)) return 0;

        const aMod = new Date(a.created);
        const bMod = new Date(b.created);

        if (aMod > bMod) return -1;
        if (aMod == bMod) return 0;
        else return 1;
      });
      break;

    case "name":
      modelsToSort.sort((a, b) => {
        if (!("name" in a)) return 0;
        if (!("name" in b)) return 0;

        const aName = a.name.toLowerCase();
        const bName = b.name.toLowerCase();

        if (aName < bName) return -1;
        if (aName == bName) return 0;
        else return 1;
      });
      break;
  }
  return modelsToSort;
}
